import styled from "@emotion/styled";

// container
export const Container = styled.div`
  height: 100%;
  display: grid;
  justify-content: center;
  align-items: center;
`;

// Login container
export const LoginContainer = styled.div`
  display: grid;
  align-items: center;
  width: 550px;
  // height: 420px;
  padding: 0 6rem;
  background: white;
  border-radius: 10px;
  box-shadow: inset 0 1px 12px -3px #fdfdfd, 0 0 16px 6px rgb(0 0 0 / 15%);
  text-align: center;
`;

export const LogoContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  margin-bottom: 2.5rem;
  margin-top: 4rem;
`;
export const LogoImage = styled.img`
  height: 40px;
  width: 40px;
`;

export const InputContainer = styled.div`
  position: relative;
  margin: 1.5rem 0;

  i {
    position: absolute;
    cursor: pointer;
    top: 13px;
    right: 20px;
  }
`;
export const Eye = styled.i`
  color: #c3c3c3;
`;

export const Button = styled.button`
  width: 100%;
  margin: 2rem 0;
  padding: 0.8rem 0rem;
  border-radius: 20px;
  background-color: #cfd12a;
  color: #161616;
  font-size: 12px;
  text-transform: capitalize;
  border: none;
  cursor: pointer;
  transition: all 200ms ease;

  &:focus,
  &:active {
    outline: none;
    border: none;
  }
  &:active {
    transform: translateY(1.5px);
  }

  &:disabled,
  &[disabled] {
    background-color: #e3e48d;
  }
`;

export const ForgetPassword = styled.div`
  width: 100%;
  cursor: pointer;
  font-size: 0.65rem;
  margin: 1rem 0;
`;
